<template>
    <div class="customer-seas-detail-wrap customer-private-seas-detail-wrap">
        <div class="page-breadcrumb">
            <div class="company-info">
                <div>
                    <div class="logo-box"><img :src="details.logo" alt="" /></div>
                    <h3>{{ details.company }}</h3>
                </div>
                <div>
                    <PersonnelCard
                        :userId="
                            customerDetail.salesperson &&
                            customerDetail.salesperson.text.length &&
                            customerDetail.salesperson.text[0].id
                        "
                        v-if="customerDetail && customerDetail.salesperson && customerDetail.salesperson.text.length"
                    >
                        <template slot="container">
                            <div
                                v-if="
                                    customerDetail &&
                                    customerDetail.salesperson &&
                                    customerDetail.salesperson.text.length
                                "
                                class="user-avatar"
                            >
                                <img :src="customerDetail.salesperson.text[0].avatar || defaultImg" alt="" />
                                <span>{{ customerDetail.salesperson.text[0].name }}</span>
                            </div>
                        </template>
                    </PersonnelCard>

                    <span class="user-address" v-if="customerDetail.country_region && customerDetail.country_region.text">{{
                        customerDetail.country_region.text
                    }}</span>
                    <span v-if="customerDetail.created_at">创建于{{ customerDetail.created_at }}</span>
                </div>
            </div>
            <div class="operator-btns">
                <i class="iconfont icon-bianji" v-if="hasEditPermission" @click="handleClickEdit">编辑</i>
                <el-dropdown placement="bottom-end" trigger="click">
                    <i class="iconfont el-icon-more">更多</i>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-if="hasEditPermission" @click.native="handleChangeDirector"> 更换负责人</el-dropdown-item>
                        <el-dropdown-item v-if="hasEditPermission" @click.native="handleClickRecovery"> 回收</el-dropdown-item>
                        <el-dropdown-item @click.native="handleClickShare"> 分享</el-dropdown-item>
                        <el-dropdown-item v-if="hasDelPermission" @click.native="handleClickDel"> 删除</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div class="page-content">
            <div class="page-content-left" v-loading="contentLoading">
                <div class="tab-item-header">
                    <span>客户信息</span>
                </div>
                <div>
                    <CustomFormDetailPc
                        v-if="editDetailsShow"
                        :field_list="formInfoList"
                        :form_detail="customerDetail"
                        :pk_id="Number(customer_id)"
                        :is_edit_mode="false"
                        :is_detail_not_edit_mode="true"
                    />
                </div>
            </div>
            <div class="page-content-middle">
                <div class="middle-tab-card middle-tab-card1">
                    <div class="tab-item-header">
                        <span>客户摘要</span>
                    </div>
                    <el-row :gap="24">
                        <el-col :span="24">
                            <span>商机数量：</span>
                            <span
                                >总{{ customerSummaryData.project && customerSummaryData.project.project_count }}/赢{{
                                    customerSummaryData.project && customerSummaryData.project.project_win
                                }}/输{{
                                    customerSummaryData.project && customerSummaryData.project.project_failed
                                }}</span
                            >
                        </el-col>
                        <el-col :span="12">
                            <span>订单数量：</span>
                            <span>{{ customerSummaryData.order_count }}单</span>
                        </el-col>
                        <el-col :span="12">
                            <span>订单总额：</span>
                            <span>{{ customerSummaryData.total_order_amount }}元</span>
                        </el-col>
                        <el-col :span="12">
                            <span>已回款金额：</span>
                            <span>{{ customerSummaryData.total_repaid_amount }}元</span>
                        </el-col>
                        <el-col :span="12">
                            <span>未回款金额：</span>
                            <span>{{ customerSummaryData.total_unrepaid_amount }}元</span>
                        </el-col>
                    </el-row>
                </div>
                <div class="middle-tab-card middle-tab-card2" v-loading="dynamicLoading">
                    <div class="tab-item-header">
                        <span>客户动态</span>
                        <div class="tab-item-header-btns">
                            <span
                                v-if="dynamicFilterForm.modelSwitch.customer_follow_ups == 'on'"
                                slot="reference"
                                class="filter-icon"
                                @click="handleClickFollowRecordAdd"
                                ><i class="iconfont icon-xiejilu"></i>写跟进</span
                            >
                            <span
                                v-if="dynamicFilterForm.modelSwitch.customer_manages == 'on'"
                                slot="reference"
                                class="filter-icon"
                                @click="handleClickManageCustomerAdd"
                                ><i class="iconfont icon-bumenfuzeren"></i>管理客户</span
                            >
                            <el-popover
                                ref="filterFormPopover"
                                :visible-arrow="false"
                                placement="bottom-end"
                                title=""
                                trigger="click"
                                width="360"
                            >
                                <div class="dynamic-filter-popper">
                                    <p>筛选</p>
                                    <div>
                                        <p>类型</p>
                                        <el-select
                                            v-model="dynamicFilterForm.type"
                                            placeholder="请选择"
                                            size="small"
                                            @change="customerLogFilter"
                                        >
                                            <el-option
                                                v-for="item in logTypeOptions"
                                                :key="item.value"
                                                :label="item.title"
                                                :value="item.value"
                                            >
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div>
                                        <p>时间</p>
                                        <el-date-picker
                                            v-model="dynamicFilterForm.dateRange"
                                            end-placeholder="结束日期"
                                            format="yyyy-MM-dd"
                                            range-separator="至"
                                            size="small"
                                            start-placeholder="开始日期"
                                            type="daterange"
                                            value-format="yyyy-MM-dd"
                                            @change="customerLogFilter"
                                        >
                                        </el-date-picker>
                                    </div>
                                </div>
                                <span class="filter-icon" slot="reference"
                                    ><i class="iconfont icon-shaixuan"></i>筛选</span
                                >
                            </el-popover>
                        </div>
                    </div>
                    <div class="dynamic-list">
                        <ul
                            v-infinite-scroll="customerLogLoadMore"
                            :infinite-scroll-delay="100"
                            :infinite-scroll-immediate="false"
                        >
                            <li class="dynamic-item" v-for="item in dynamicList" :key="item.id">
                                <div class="dynamic-item-title">
                                    <PersonnelCard :userId="item.log_user.id" v-if="item.log_user && item.log_user.id">
                                        <template slot="container">
                                            <div class="user-avatar-btn">
                                                <img
                                                    :src="
                                                        item.log_user && item.log_user.avatar
                                                            ? item.log_user.avatar
                                                            : defaultImg
                                                    "
                                                    alt=""
                                                />
                                                <span class="dynamic-item-name">{{
                                                    item.log_user && item.log_user.name
                                                }}</span>
                                            </div>
                                        </template>
                                    </PersonnelCard>
                                    <span class="dynamic-item-time">{{ item.created_date }}</span>
                                    <span
                                        v-if="dynamicTypeTagList.includes(item.type)"
                                        :class="['dynamic-tag', 'dynamic-tag-' + item.type]"
                                        >{{ item.type_name }}</span
                                    >
                                </div>
                                <div class="dynamic-item-content">
                                    <template v-if="item.type == 'project_add'">
                                        <template v-if="item.content && item.content.content">
                                            <span
                                                class="link-label"
                                                @click="
                                                    handleClickBusinessDetail(
                                                        item.relate_id,
                                                        item.content.content.project_name
                                                    )
                                                "
                                                >{{ item.content.content.project_name }}</span
                                            >
                                            <span>{{ item.content.content.project_stage_name }}</span>
                                        </template>
                                    </template>
                                    <template v-else-if="item.type == 'new_work_order'">
                                        <span class="link-label">{{ item.content && item.content.content &&  item.content.content.workorder_num}}</span>
                                        <span>{{ item.content && item.content.content &&  item.content.content.workorder_status_text }}</span>
                                        <span>{{ item.content && item.content.content &&  item.content.content.workorder_type_text }}</span>
                                    </template>
                                    <template v-else-if="item.type == 'order_add'">
                                        <span class="link-label" @click="handleClickLogOrderDetail(item.content && item.content.content)">{{ item.content && item.content.content && item.content.content.order_num }}</span>
                                        <span>{{  item.content && item.content.content && item.content.content.salesperson &&  item.content.content.salesperson.name}} </span>
                                        <span>¥{{ item.content && item.content.content && item.content.content.total_price }}</span>
                                    </template>
                                    <template v-else-if="item.type == 'manage'">
                                        <p>{{ item.content && item.content.content }}</p>
                                        <template
                                            v-if="item.is_open && item.extendDetail"
                                            v-loading="manageCustomerDetailLoading"
                                        >
                                            <CustomFieldsDetailForm
                                                v-if="item.is_open"
                                                :custom_form_class="'manage_customer_form'"
                                                :details="item.extendDetail"
                                                :field_table="'customer_manages'"
                                                :filter_system="true"
                                                :form_label_position="'left'"
                                                :form_label_suffix="'：'"
                                                @loading-change="manageCustomerDetailLoadingChange"
                                            ></CustomFieldsDetailForm>
                                        </template>
                                        <div
                                            :class="{ 'is-collapsed-up': item.is_open }"
                                            class="is-collapsed-down"
                                            @click="handleClickCollapsed(item)"
                                        >
                                            <span>{{ item.is_open ? "收起" : "展开" }}</span
                                            ><img
                                                src="https://download.hecoos.com/enlightv/2024-45/5dcd224158f9ca176d74045d01d456e8.png"
                                                alt=""
                                            />
                                        </div>
                                    </template>
                                    <template v-else-if="item.type == 'change'">
                                        <span>客户等级：</span>
                                        <span>A级—B级</span>
                                    </template>
                                    <template v-else-if="item.type == 'follow_up'">
                                        <p>
                                            {{ item.content && item.content.content }}
                                        </p>
                                        <div class="is-collapsed-down" @click="handleClickFollowRecordDetail(item)">
                                            <span>详情</span
                                            ><img
                                                src="https://download.hecoos.com/enlightv/2024-45/d773cf7f7e8c2899137cf875c60da210.png"
                                                alt=""
                                            />
                                        </div>
                                    </template>
                                    <template v-else>
                                        <template v-if="item.type_detail == 'edit_customer'">
                                            <span>{{ item.type_name }}</span>
                                        </template>
                                        <span v-else>{{ item.content && item.content.content }}</span>
                                    </template>
                                </div>
                            </li>
                        </ul>
                        <div class="detail-no-data-wrap" v-if="!dynamicList.length">
                            <p>暂无数据</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-content-right">
                <ul>
                    <el-popover
                        :visible-arrow="false"
                        placement="left"
                        popper-class="custom-tab-popper custom-tab-popper-personnel-private"
                        title=""
                        trigger="hover"
                        width="360"
                    >
                        <div class="custom-tab-popper-wrap">
                            <div class="custom-tab-popper-title custom-tab-popper-title1">
                                <span>联系人（{{ contactList.length }}）</span>
                                <el-button type="text" class="link-label" @click="handleClickAddCrmContact"
                                    ><i class="iconfont icon-tianjia1"></i>新增联系人
                                </el-button>
                            </div>
                            <div
                                v-loading="contactLoading"
                                class="custom-tab-popper-content custom-tab-popper-personnel-content"
                            >
                                <ul v-if="contactList.length">
                                    <li v-for="(item, index) in contactList" :key="index">
                                        <span class="link-label ellipsis" @click="handleClickPersonnelDetail(item)">{{
                                            item.name
                                        }}</span>
                                        <span>{{ item.phone ? phoneEncryption(item.phone) : "" }}</span>
                                    </li>
                                </ul>
                                <div class="detail-no-data-wrap" v-else>
                                    <p>暂无数据</p>
                                </div>
                            </div>
                        </div>
                        <li slot="reference">
                            <img :src="tabList[0].icon" alt="联系人" />
                            <span>{{ tabList[0].label }}</span>
                        </li>
                    </el-popover>
                    <el-popover
                        :visible-arrow="false"
                        placement="left"
                        popper-class="custom-tab-popper custom-tab-popper-company-private"
                        title=""
                        trigger="hover"
                        width="360"
                    >
                        <div class="custom-tab-popper-wrap">
                            <div class="custom-tab-popper-title">
                                <span>关联客户（{{ relatedCompanyList.length }}）</span>
                                <el-button type="text" class="link-label" @click="handleClickRelatedCompanyAdd"
                                    ><i class="iconfont icon-tianjia1"></i>添加关联
                                </el-button>
                            </div>
                            <div
                                v-loading="relatedCompanyLoading"
                                class="custom-tab-popper-content custom-tab-popper-personnel-content"
                            >
                                <ul v-if="relatedCompanyList.length">
                                    <li v-for="(item, index) in relatedCompanyList" :key="index">
                                        <span class="link-label ellipsis">{{ item.name }}</span>
                                        <div class="popover_item_flex">
                                            <span>{{ item.salesperson && item.salesperson.name }}</span>
                                            <i
                                                class="iconfont icon-shanchu1 custom-tooltip-icon"
                                                @click.stop="handleRelatedCompanyDel(item, index)"
                                            ></i>
                                        </div>
                                    </li>
                                </ul>
                                <div class="detail-no-data-wrap" v-else>
                                    <p>暂无数据</p>
                                </div>
                            </div>
                        </div>
                        <li slot="reference">
                            <img :alt="tabList[1].label" :src="tabList[1].icon" />
                            <span>{{ tabList[1].label }}</span>
                        </li>
                    </el-popover>
                    <el-popover
                        :visible-arrow="false"
                        placement="left"
                        popper-class="custom-tab-popper custom-tab-popper-members"
                        title=""
                        trigger="hover"
                        width="360"
                    >
                        <div class="custom-tab-popper-wrap">
                            <div class="custom-tab-popper-title">
                                <span>团队成员（{{ memberList.length }}）</span>
                                <el-button type="text" class="link-label" @click="handleTeamMemberAdd"
                                    ><i class="iconfont icon-tianjia1"></i>添加成员
                                </el-button>
                            </div>
                            <div
                                v-loading="memberLoading"
                                class="custom-tab-popper-content custom-tab-popper-member-content"
                            >
                                <ul v-if="memberList.length">
                                    <li v-for="item in memberList" :key="item.id" class="member-item">
                                        <PersonnelCard
                                            :userId="item.member_uid"
                                            v-if="item.member_user && item.member_user.name"
                                        >
                                            <template slot="container">
                                                <div class="user-avatar-btn" v-if="item.member_user">
                                                    <img :src="item.member_user.avatar || defaultImg" alt="" />
                                                    <span>{{ item.member_user.name }}</span>
                                                </div>
                                            </template>
                                        </PersonnelCard>
                                        <div>
                                            <el-radio-group
                                                v-model="item.auth"
                                                @change="handleChangeMemberAuth(item, 'update')"
                                            >
                                                <el-radio :label="1">只读</el-radio>
                                                <el-radio :label="2">读写</el-radio>
                                            </el-radio-group>
                                            <i
                                                class="iconfont icon-shanchu1 custom-tooltip-icon"
                                                @click.stop="handleChangeMemberAuth(item, 'delete')"
                                            ></i>
                                        </div>
                                    </li>
                                </ul>
                                <div class="detail-no-data-wrap" v-else>
                                    <p>暂无数据</p>
                                </div>
                            </div>
                        </div>
                        <li slot="reference">
                            <img :alt="tabList[1].label" :src="tabList[2].icon" />
                            <span>{{ tabList[2].label }}</span>
                        </li>
                    </el-popover>
                    <el-popover
                        :visible-arrow="false"
                        placement="left"
                        popper-class="custom-tab-popper custom-tab-popper-order-private"
                        title=""
                        trigger="hover"
                        width="360"
                    >
                        <div class="custom-tab-popper-wrap">
                            <div class="custom-tab-popper-title">
                                <span>关联订单（{{ orderPagination.total }}）</span>
                                <el-button type="text" class="link-label" v-if="hasOrderPermission" @click="handleClickAddOrder"
                                    ><i class="iconfont icon-tianjia1"></i>新增订单
                                </el-button>
                            </div>
                            <div
                                v-loading="orderListLoading"
                                class="custom-tab-popper-content custom-tab-popper-order-content"
                            >
                                <ul 
                                    v-infinite-scroll="relatedOrderListLoadMore"
                                    :infinite-scroll-delay="100"
                                    :infinite-scroll-immediate="false"
                                    infinite-scroll-distance="20">
                                    <li v-for="(item, index) in relatedOrderList" :key="index" class="order-item">
                                        <div class="order-item-title">
                                            <span class="link-label ellipsis" @click="handleClickOrderDetail(item)">{{
                                                item.order_num
                                            }}</span>
                                            <span>{{ item.created_at }}</span>
                                        </div>
                                        <div class="order-item-content">
                                            <PersonnelCard
                                                :userId="item.salesperson.id"
                                                v-if="item.salesperson && item.salesperson.id"
                                            >
                                                <template slot="container">
                                                    <div class="user-avatar-btn">
                                                        <img
                                                            alt=""
                                                            :src="
                                                                item.salesperson && item.salesperson.avatar
                                                                    ? item.salesperson.avatar
                                                                    : defaultImg
                                                            "
                                                        />
                                                        <span>{{ item.salesperson && item.salesperson.name }}</span>
                                                    </div>
                                                </template>
                                            </PersonnelCard>
                                            <span>¥{{ item.total_price }}</span>
                                        </div>
                                    </li>
                                </ul>
                                <!-- <div class="detail-no-data-wrap">
                                    <p>暂无数据</p>
                                </div> -->
                            </div>
                        </div>
                        <li slot="reference">
                            <img :alt="tabList[3].label" :src="tabList[3].icon" />
                            <span>{{ tabList[3].label }}</span>
                        </li>
                    </el-popover>
                    <el-popover
                        :visible-arrow="false"
                        placement="left"
                        popper-class="custom-tab-popper custom-tab-popper-business-private"
                        title=""
                        trigger="hover"
                        width="360"
                    >
                        <div class="custom-tab-popper-wrap">
                            <div class="custom-tab-popper-title">
                                <span>关联商机（{{ projectsPagination.total }}）</span>
                                <el-button type="text" class="link-label" v-if="hasProjectPermission" @click="handleClickAddBusiness"
                                    ><i class="iconfont icon-tianjia1"></i>新增商机
                                </el-button>
                            </div>
                            <div
                                v-loading="projectsListLoading"
                                class="custom-tab-popper-content custom-tab-popper-personnel-content"
                            >
                                <ul
                                    v-infinite-scroll="relatedProjectsLoadMore"
                                    :infinite-scroll-delay="100"
                                    :infinite-scroll-immediate="false"
                                    infinite-scroll-distance="20">
                                    <li v-for="(item, index) in relatedProjectsList" :key="index" class="business-item">
                                        <span
                                            class="link-label ellipsis"
                                            @click="handleClickBusinessDetail(item.project_id, item.name)"
                                            >{{ item.name }}</span
                                        >
                                        <span>{{ item.project_stage && item.project_stage.text }}</span>
                                    </li>
                                </ul>
                                <!-- <div class="detail-no-data-wrap" v-else>
                                    <p>暂无数据</p>
                                </div> -->
                            </div>
                        </div>
                        <li slot="reference">
                            <img :alt="tabList[4].label" :src="tabList[4].icon" />
                            <span>{{ tabList[4].label }}</span>
                        </li>
                    </el-popover>
                    <el-popover
                        :visible-arrow="false"
                        placement="left"
                        popper-class="custom-tab-popper custom-tab-popper-work-private"
                        title=""
                        trigger="hover"
                        width="360"
                    >
                        <div class="custom-tab-popper-wrap">
                            <div class="custom-tab-popper-title">
                                <span>关联工单（{{ workOrderPagination.total }}）</span>
                            </div>
                            <div v-loading="workOrderListLoading" class="custom-tab-popper-content custom-tab-popper-work-content">
                                <ul
                                    v-infinite-scroll="workOrderListLoadMore"
                                    :infinite-scroll-delay="100"
                                    :infinite-scroll-immediate="false"
                                    infinite-scroll-distance="20"
                                >
                                    <li v-for="(item, index) in relatedWorkOrderList" :key="index" class="work-item">
                                        <div class="work-item-title">
                                            <div>
                                                <span class="link-label ellipsis" @click="handleClickWorkOrderDetail(item)">{{ item.workorder_num }}</span>
                                                <span v-if="item.status === 6">{{ item.status_text }}</span>
                                            </div>
                                            <span>{{ item.created_at }}</span>
                                        </div>
                                        <div class="work-item-content">
                                            <span>{{ item.workorder_type_id && item.workorder_type_id.name }} </span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <li slot="reference">
                            <img :alt="tabList[5].label" :src="tabList[5].icon" />
                            <span>{{ tabList[5].label }}</span>
                        </li>
                    </el-popover>
                </ul>
            </div>
        </div>
        <el-dialog
            v-if="deleteCustomerDialog"
            :before-close="handledeleteCustomerDialogClose"
            :close-on-click-modal="false"
            :visible.sync="deleteCustomerDialog"
            class="custom-dialog custom-tooltip-confirm-dialog"
            title=""
            width="390px"
        >
            <div class="flex">
                <i class="dialog-left-icon iconfont icon-jinggao"></i>
                <div>
                    <p class="tooltip-confirm-title">您确定要删除吗？</p>
                    <p>删除后不可恢复，请谨慎操作！</p>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handledeleteCustomerDialogClose">取消</el-button>
                <el-button type="danger" @click="handledeleteCustomerConfirm">删除</el-button>
            </span>
        </el-dialog>
        <el-dialog
            v-if="relateCustomFormVisible"
            :before-close="handleClickCrmContactCancel"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :modal-append-to-body="false"
            :title="'新增关联联系人'"
            :visible.sync="relateCustomFormVisible"
            custom-class="custom_form_dialog relate_custom_form_dialog"
            width="560px"
        >
            <div class="custom_form_body">
                <CustomFormPc
                    ref="relateCustomForm"
                    :field_list="relateCustomFormFields"
                    :pk_id="relate_form_id"
                    @submit-form="relateCustomerSummitFormData"
                >
                </CustomFormPc>
            </div>
            <div slot="footer">
                <el-button size="small" @click="handleClickCrmContactCancel">取消</el-button>
                <el-button :disabled="btnDisabled" size="small" type="primary" @click="handleClickCrmContactConfirm"
                    >保存
                </el-button>
            </div>
        </el-dialog>
        <CustomerAdd
            v-if="addDialogVisible"
            :addDialogVisible.sync="addDialogVisible"
            :editId="customer_id"
            @operateSuccessCallback="getCustomerPrivateDetail"
        />
        <DirectorChange
            v-if="directorChangeVisible"
            :directorChangeVisible.sync="directorChangeVisible"
            :selectedList="selectedTableData"
            @updateCallback="getCustomerPrivateDetail"
        />
        <CustomerRecovery
            v-if="customerRecoveryVisible"
            :customerRecoveryVisible.sync="customerRecoveryVisible"
            :selectedList="selectedTableData"
            @updateCallback="getCustomerPrivateDetail"
        />
        <ShareDialog
            v-if="shareDialog"
            :shareCustomerId="customer_id"
            :shareCustomerName="details.company"
            :shareDialog.sync="shareDialog"
        />
        <FollowRecordDetails
            v-if="followRecordDetailsVisible"
            :followRecordDetailsVisible.sync="followRecordDetailsVisible"
            :followRecordId.sync="followRecordId"
        />
        <RelatedCompanyAdd
            v-if="relatedCompanyVisible"
            :customer_id.sync="customer_id"
            :relatedCompanyVisible.sync="relatedCompanyVisible"
            @updateCallback="getRelateCustomersList"
        />
        <TeamMembersAdd
            v-if="teamMembersAddVisible"
            :customer_id.sync="customer_id"
            :teamMembersAddVisible.sync="teamMembersAddVisible"
            @createCallback="getCustomerMemberList"
        />
        <ManageCustomerTpl
            v-if="manageCustomerTplVisible"
            :customer_id.sync="customer_id"
            :manageCustomerTplVisible.sync="manageCustomerTplVisible"
            @createCallback="customerLogFilter"
        />
        <FollowRecordAdd
            v-if="followRecordAddVisible"
            :customer_id.sync="customer_id"
            :followRecordAddVisible.sync="followRecordAddVisible"
            @createCallback="customerLogFilter"
        />
        <PersonnelDetail
            v-if="personnelDetailVisible"
            :contactId="contactId"
            :personnelDetailVisible.sync="personnelDetailVisible"
        />
        <businessAdd
            v-if="addBusinessDialogVisible"
            @refresh-list="initRelateProjectsData"
            :dialogVisible.sync="addBusinessDialogVisible"
        />
        <orderAdd
            v-if="addOrderDialogVisible"
            :dialogVisible.sync="addOrderDialogVisible"
            @refresh-list="initRelateOrdersData"
        />
    </div>
</template>
<script>
import {
    GetCustomerPrivateDetail,
    GetContactList,
    GetCustomerLogTypeList,
    GetCustomerLogList,
    GetCustomerMemberList,
    HandleCustomerMember,
    CustomerPrivateDel,
    GetCustomerManageDetail,
    getFormFields,
    ContactAdd,
    GetCompanySwitchList,
    CustomerSummary,
    CustomerRelateOrders,
    CustomerRelateProjects,
    RelateCustomersList,
    getWorkOrderList,
    DelRelateCustomer,
    getOrderList,
    getProjectList
} from "@/api";
import { phoneEncryption, formatDate } from "@/utils";
import CustomerAdd from "./component/customer_add.vue";
import DirectorChange from "./component/director_change.vue";
import CustomerRecovery from "./component/customer_recovery.vue";
import ShareDialog from "./component/share_dialog.vue";
import RelatedCompanyAdd from "./component/related_company_add.vue";
import TeamMembersAdd from "./component/team_members_add.vue";
import ManageCustomerTpl from "./component/manage_customer_tpl.vue";
import PersonnelCard from "@/components/pComponents/PersonnelCard.vue";
import PersonnelDetail from "@/components/pComponents/personnel_detail.vue";
import FollowRecordAdd from "./component/follow_record_add.vue";
import FollowRecordDetails from "./component/follow_record_details.vue";
import CustomFieldsDetailForm from "@/components/pComponents/CustomFieldsDetailForm.vue";
import CustomFormPc from "@/components/pComponents/CustomFormPc";
import CustomFormDetailPc from "@/components/pComponents/CustomFormDetailPc";
import businessAdd from "../Business/component/business_add";
import orderAdd from "../Order/component/order_add";
import {mapGetters} from "vuex";

export default {
    name: "CustomerPrivateSeasDetail",
    components: {
        CustomerAdd,
        DirectorChange,
        CustomerRecovery,
        ShareDialog,
        RelatedCompanyAdd,
        TeamMembersAdd,
        ManageCustomerTpl,
        FollowRecordAdd,
        FollowRecordDetails,
        PersonnelCard,
        PersonnelDetail,
        CustomFieldsDetailForm,
        CustomFormPc,
        CustomFormDetailPc,
        businessAdd,
        orderAdd
    },
    data() {
        return {
            customer_id: this.$route.query.customer_id,
            defaultImg: require("@/assets/images/default.jpg"),
            contentLoading: false,
            formInfoList: [],
            customerDetail: {},
            editDetailsShow: true,
            details: {
                id: "",
                logo: "",
                company: "",
                createTime: "", // 创建时间
            },
            // 客户摘要信息
            customerSummaryData: {
                project: {},
                order_count: 0,
                total_order_amount: 0,
                total_repaid_amount: 0,
                total_unrepaid_amount: 0,
            },
            dynamicFilterForm: {
                type: "",
                dateRange: [],
                page: 1,
                total: 0,
                modelSwitch: {
                    customer_follow_ups: "",
                    customer_manages: "",
                },
            },
            logTypeOptions: [],
            dynamicLoading: false,
            dynamicTypeTagList: ["follow_up", "manage", "project_add", "order_add", "new_work_order", "customer_change"],
            dynamicList: [],
            manageCustomerDetailLoading: false,
            tabList: [
                {
                    name: "personnel",
                    label: "联系人",
                    icon: "https://download.hecoos.com/enlightv/2024-44/2fc84690f2728a31b692573b536c41d6.png",
                },
                {
                    name: "relateCompany",
                    label: "关联客户",
                    icon: "https://download.hecoos.com/enlightv/2024-44/a98076872e85fff529dd6fc18d9af863.png",
                },
                {
                    name: "members",
                    label: "团队成员",
                    icon: "https://download.hecoos.com/enlightv/2024-44/8af52fbebfd5c96b377f890d49fffa6b.png",
                },
                {
                    name: "personnel",
                    label: "订单",
                    icon: "https://download.hecoos.com/enlightv/2024-44/f37ea85f5692a2dfb5bedbc45c4f1aa3.png",
                },
                {
                    name: "personnel",
                    label: "商机",
                    icon: "https://download.hecoos.com/enlightv/2024-44/fde5131248211d41bb8c0d2f719a5756.png",
                },
                {
                    name: "personnel",
                    label: "工单",
                    icon: "https://download.hecoos.com/enlightv/2024-44/ddd0ee97e996ec429fcccbbe7ac99f46.png",
                },
            ],
            contactLoading: false,
            contactList: [],
            relatedCompanyLoading: false,
            relatedCompanyList: [],
            memberLoading: false,
            memberList: [],
            orderPagination: {
                pageNum: 1,
                pageSize: 20,
                total: 0,
            },
            orderListLoading: false,
            relatedOrderList: [],
            projectsPagination: {
                pageNum: 1,
                pageSize: 20,
                total: 0,
            },
            projectsListLoading: false,
            relatedProjectsList: [],
            workOrderPagination: {
                pageNum: 1,
                pageSize: 20,
                total: 0,
            },
            workOrderListLoading: false,
            relatedWorkOrderList: [],

            currentUserInfo: {}, // 用户信息
            addDialogVisible: false, // 添加、编辑
            directorChangeVisible: false, // 更换负责人
            customerRecoveryVisible: false, // 回收
            deleteCustomerDialog: false, // 删除
            selectedTableData: [], // 弹框需要 复选框选中的数据
            shareDialog: false, // 分享
            relatedCompanyVisible: false, // 管理公司添加
            teamMembersAddVisible: false, // 团队成员添加
            manageCustomerTplVisible: false, // 管理客户
            followRecordAddVisible: false, // 跟进记录添加
            followRecordId: "",
            followRecordDetailsVisible: false, // 跟进记录详情
            contactId: "", // 联系人id
            personnelDetailVisible: false, // 联系人详情
            relateCustomFormVisible: false, // 新增关联联系人弹框
            relateCustomFormFields: [],
            relate_form_id: 0,
            btnDisabled: false,
            phoneEncryption,

            addBusinessDialogVisible: false,
            addOrderDialogVisible: false,
        };
    },
    computed: {
        ...mapGetters(['hasPermission']),
        // 编辑权限，可对客户信息新增、编辑、更换客户负责人、回收及合并客户
        hasEditPermission() {
            return this.hasPermission('customerPrivate.edit', 'customer', 'CustomerPrivateSeas');
        },
        // 删除权限
        hasDelPermission() {
            return this.hasPermission('customerPrivate.del', 'customer', 'CustomerPrivateSeas');
        },    
        // 新增订单
        hasOrderPermission() {
            return this.hasPermission('order.edit', 'customer', 'Order');
        },
        // 新增商机
        hasProjectPermission() {
            return this.hasPermission('project.edit', 'customer', 'Project');
        },
    },
    created() {
        this.details.company = this.$route.query.name;
        this.getCustomerPrivateDetail();
    },
    methods: {
        //详情加载状态
        detailLoadingChange(loading) {
            this.contentLoading = loading;
        },
        // 获取客户详情
        getCustomerPrivateDetail() {
            this.contentLoading = true;
            getFormFields({
                field_form: "customers",
            }).then((res) => {
                if (res.code === 200) {
                    this.formInfoList = res.data || [];
                } else {
                    this.$message.error(res.message);
                }
                GetCustomerPrivateDetail(this.customer_id).then((res) => {
                    if (res.code === 200) {
                        this.customerDetail = JSON.parse(JSON.stringify(res.data));
                        this.project_ids = this.customerDetail.project_ids;
                        this.order_ids = this.customerDetail.order_ids;
                        this.editDetailsShow = false;
                        this.$nextTick(() => {
                            this.editDetailsShow = true;
                        });
                        this.getCustomerSummary();
                        this.getContactList();
                        this.getCustomerLogTypeList();
                        this.getCompanySwitchList();
                        this.getCustomerMemberList();
                        this.getRelateCustomersList();
                        this.getCustomerRelateOrders();
                        this.getCustomerRelateProjects();
                        this.getCustomerRelateWorkOrderListData();
                    }
                    this.contentLoading = false;
                });
            });
        },
        // 获取客户摘要
        getCustomerSummary() {
            const params = {
                customer_id: this.customer_id,
            };
            CustomerSummary(params).then((res) => {
                if (res.code === 200) {
                    this.customerSummaryData = res.data || {};
                }
            });
        },
        // 获取联系人列表
        getContactList() {
            this.contactLoading = true;
            GetContactList({ name: "", customer_id: this.customer_id }).then((res) => {
                if (res.code === 200) {
                    const { list, total } = res.data;
                    this.contactList = list || [];
                } else {
                    this.contactList = [];
                }
                this.contactLoading = false;
            });
        },
        // 获取关联客户列表
        getRelateCustomersList() {
            const params = {
                customer_id: this.customer_id,
            };
            RelateCustomersList(params).then((res) => {
                if (res.code === 200) {
                    this.relatedCompanyList = res.data || [];
                } else {
                    this.relatedCompanyList = [];
                }
            });
        },
        // 初始化关联订单信息
        initRelateOrdersData() {
            this.orderPagination.pageNum = 1;
            this.orderPagination.total = 0;
            this.relatedOrderList = [];
            this.getCustomerRelateOrders();
        },
        // 加载更多订单信息
        relatedOrderListLoadMore() {
            if (this.orderListLoading || this.relatedOrderList.length == this.orderPagination.total) {
                return false;
            }
            this.orderPagination.pageNum += 1;
            this.getCustomerRelateOrders();
        },
        // 获取关联订单
        getCustomerRelateOrders() {
            this.orderListLoading = true;
            const params = {
                page: this.orderPagination.pageNum,
                pageSize: this.orderPagination.pageSize,
                keyword: "",
                customer_id: this.customer_id,
            };
            getOrderList(params).then((res) => {
                if (res.code === 200) {
                    const { data, total } = res.data;
                    let relatedOrderList = data.map((item) => {
                        item.created_at = item.created_at ? formatDate(item.created_at, "date") : item.created_at;
                        return item;
                    });
                    this.orderListLoading = false;
                    this.relatedOrderList = this.relatedOrderList.concat(relatedOrderList || []);
                    this.orderPagination.total = total;
                } else {
                    this.relatedOrderList = [];
                    this.orderListLoading = false;
                }
            });
        },
        // 初始化关联商机信息
        initRelateProjectsData() {
            this.projectsPagination.pageNum = 1;
            this.projectsPagination.total = 0;
            this.relatedProjectsList = [];
            this.getCustomerRelateProjects();
        },
        // 加载更多商机信息
        relatedProjectsLoadMore() {
            if (this.projectsListLoading || this.relatedProjectsList.length == this.projectsPagination.total) {
                return false;
            }
            this.projectsPagination.pageNum += 1;
            this.getCustomerRelateProjects();
        },
        // 获取关联商机
        getCustomerRelateProjects() {
            this.projectsListLoading = true;
            const params = {
                keyword: "",
                page: this.projectsPagination.pageNum,
                pageSize: this.projectsPagination.pageSize,
                customer_id: this.customer_id,
            };
            getProjectList(params).then((res) => {
                if (res.code === 200) {
                    const { data, total } = res.data;
                    this.projectsListLoading = false;
                    this.relatedProjectsList = this.relatedProjectsList.concat(data || []);
                    this.projectsPagination.total = total;
                } else {
                    this.projectsListLoading = false;
                    this.relatedProjectsList = [];
                }
            });
        },
        // 加载更多工单信息
        workOrderListLoadMore() {
            if (this.workOrderListLoading || this.relatedWorkOrderList.length == this.workOrderPagination.total) {
                return false;
            }
            this.workOrderPagination.pageNum += 1;
            this.getCustomerRelateWorkOrderListData();
        },
        // 获取关联工单
        getCustomerRelateWorkOrderListData() {
            this.workOrderListLoading = true;
            getWorkOrderList({
                page: this.workOrderPagination.pageNum,
                pageSize: this.workOrderPagination.pageSize,
                keyword: "",
                tab: "",
                project_id: this.project_ids,
                order_id: this.order_ids && this.order_ids.length ? this.order_ids.join(",") : "",
            }).then((res) => {
                if (res.code === 200) {
                    const { data, total } = res.data;
                    data.forEach((item) => {
                        this.$set(item, "workorder_id", item.id);
                    });
                    this.workOrderListLoading = false;
                    this.relatedWorkOrderList = this.relatedWorkOrderList.concat(data || []);
                    this.workOrderPagination.total = total;
                } else {
                    this.workOrderListLoading = false
                }
            });
        },
        // 新建订单
        handleClickAddOrder() {
            this.addOrderDialogVisible = true;
        },
        // 获取跟进记录和管理记录开发列表
        getCompanySwitchList() {
            GetCompanySwitchList().then((res) => {
                const data = res.data || [];
                data.forEach((item) => {
                    this.dynamicFilterForm.modelSwitch[item.type] = item.status;
                });
                this.customerLogFilter();
            });
        },
        // 获取日志类型
        getCustomerLogTypeList() {
            GetCustomerLogTypeList().then((res) => {
                if (res.code === 200) {
                    this.logTypeOptions = res.data || [];
                    this.logTypeOptions.unshift({ title: "全部", value: "" });
                }
            });
        },
        // 日志筛选
        customerLogFilter() {
            this.dynamicFilterForm.page = 1;
            this.dynamicFilterForm.total = 0;
            this.dynamicList = [];
            this.getCustomerLogList();
        },
        // 获取日志信息
        getCustomerLogList() {
            this.$refs.filterFormPopover && this.$refs.filterFormPopover.doClose();
            this.dynamicLoading = true;
            const params = {
                keyword: "",
                customer_id: this.customer_id,
                type: this.dynamicFilterForm.type,
                dateRange:
                    this.dynamicFilterForm.dateRange && this.dynamicFilterForm.dateRange.length
                        ? this.dynamicFilterForm.dateRange.join(" - ")
                        : "",
                page: this.dynamicFilterForm.page,
                pageSize: 10,
                modelSwitch: this.dynamicFilterForm.modelSwitch,
            };
            GetCustomerLogList(params).then((res) => {
                if (res.code === 200) {
                    const { list, total } = res.data;
                    this.dynamicList = this.dynamicList.concat(list || []);
                    this.dynamicFilterForm.total = Number(total);
                }
                this.dynamicLoading = false;
            });
        },
        // 加载更多日志信息
        customerLogLoadMore() {
            if (this.dynamicLoading || this.dynamicList.length == this.dynamicFilterForm.total) {
                return false;
            }
            this.dynamicFilterForm.page += 1;
            this.getCustomerLogList();
        },
        // 获取成员列表信息
        getCustomerMemberList() {
            this.memberLoading = true;
            GetCustomerMemberList({ customer_id: this.customer_id }).then((res) => {
                if (res.code === 200) {
                    this.memberList = res.data || [];
                } else {
                    this.memberList = [];
                }
                this.memberLoading = false;
            });
        },
        // 成员信息操作
        handleChangeMemberAuth(item, type) {
            let params = {
                customer_id: this.customer_id,
            };
            if (type === "update") {
                params.update = [
                    {
                        id: item.id,
                        member_uid: item.member_uid,
                        auth: item.auth,
                    },
                ];
            } else {
                params.delete = [item.id];
            }
            HandleCustomerMember(params)
                .then((res) => {
                    if (res.code === 200) {
                        this.$message.success(res.message);
                        this.getCustomerMemberList();
                    } else {
                        this.$message.error(res.message);
                    }
                })
                .catch((res) => {
                    this.$message.error(res.message);
                });
        },
        handleClickEdit() {
            this.addDialogVisible = true;
        },
        // 更换负责人
        handleChangeDirector() {
            this.selectedTableData = [{ id: this.customer_id, name: { value: this.details.company } }];
            this.directorChangeVisible = true;
        },
        // 回收
        handleClickRecovery() {
            this.selectedTableData = [{ id: this.customer_id, name: { value: this.details.company } }];
            this.customerRecoveryVisible = true;
        },
        // 分享
        handleClickShare(row) {
            this.shareDialog = true;
        },
        // 删除
        handleClickDel(row) {
            this.deleteCustomerDialog = true;
        },
        handledeleteCustomerDialogClose() {
            this.deleteCustomerDialog = false;
        },
        handledeleteCustomerConfirm() {
            CustomerPrivateDel({ customer_ids: [this.customer_id] }).then((res) => {
                if (res.code === 200) {
                    this.$message.success(res.message);
                    this.deleteCustomerDialog = false;
                    this.$router.go(-1);
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 添加关联客户
        handleClickRelatedCompanyAdd() {
            this.relatedCompanyVisible = true;
        },
        // 删除关联客户
        handleRelatedCompanyDel(item, index) {
            const params = {
                customer_id: this.customer_id,
                relate_customer_ids: [item.id],
            };
            DelRelateCustomer(params).then((res) => {
                if (res.code === 200) {
                    this.relatedCompanyList.splice(index, 1);
                    this.$message.success("删除成功")
                }
            });
        },
        // 添加团队成员
        handleTeamMemberAdd() {
            this.teamMembersAddVisible = true;
        },
        // 管理客户
        handleClickManageCustomerAdd() {
            this.manageCustomerTplVisible = true;
        },
        // 添加跟进记录
        handleClickFollowRecordAdd() {
            this.followRecordAddVisible = true;
        },
        // 查看联系人详细信息
        handleClickPersonnelDetail({ id }) {
            this.contactId = Number(id);
            this.personnelDetailVisible = true;
        },
        // 新增客户联系人
        handleClickAddCrmContact() {
            getFormFields({
                field_form: "customer_contacts",
            })
                .then((res) => {
                    if (res.code === 200) {
                        this.relateCustomFormFields = res.data;
                        this.relateCustomFormVisible = true;
                    } else {
                        this.$message.error(res.message);
                    }
                })
                .catch(() => {});
        },
        //新增客户联系人取消事件
        handleClickCrmContactCancel() {
            this.relateCustomFormVisible = false;
            this.relate_form_id = 0;
            this.$nextTick(()=> {
                // 当从别的页面弹框里面跳转进来，再打开的弹框关闭不了，需要手动移除
                // 手动移除多余的遮罩层
                const modals = document.querySelectorAll('.customer-private-seas-detail-wrap .v-modal');
                const custom_form_dialog = document.querySelectorAll('.customer-private-seas-detail-wrap .relate_custom_form_dialog')
                if (modals.length == 1 && !custom_form_dialog.length) {
                    modals.forEach(modal => {
                        modal.remove();
                    });
                }
            })
        },

        //新增客户联系人确认事件
        handleClickCrmContactConfirm() {
            this.$refs.relateCustomForm.handleClickPublish();
        },
        // 新增联系人提交
        relateCustomerSummitFormData(customForm) {
            if (customForm) {
                ContactAdd({ customer_id: this.customer_id, ...customForm })
                    .then((res) => {
                        if (res.code === 200) {
                            this.$message.success(res.message);
                            this.handleClickCrmContactCancel();
                            this.getCustomerPrivateDetail();
                            this.btnDisabled = false;
                        } else {
                            this.$message.error(res.message);
                        }
                    })
                    .catch(() => {});
            }
        },
        // 展开和收起
        async handleClickCollapsed(item) {
            this.manageCustomerDetailLoading = true;
            if (!item.hasOwnProperty("is_open")) {
                await this.getCustomerManageDetail(item);
                this.$set(item, "is_open", true);
            } else {
                item.is_open = !item.is_open;
            }
        },
        manageCustomerDetailLoadingChange(loading) {
            this.manageCustomerDetailLoading = loading;
        },
        // 查看跟进记录详情
        handleClickFollowRecordDetail(item) {
            this.followRecordId = item.relate_id;
            this.followRecordDetailsVisible = true;
        },
        // 查看管理记录详情
        getCustomerManageDetail(item) {
            GetCustomerManageDetail(item.relate_id).then((res) => {
                if (res.code === 200) {
                    this.$set(item, "extendDetail", res.data || {});
                }
            });
        },
        //新增商机事件
        handleClickAddBusiness() {
            this.addBusinessDialogVisible = true;
        },
        //点击查看商机详情
        handleClickBusinessDetail(project_id, name) {
            this.$router.push({
                name: "BusinessDetail",
                params: {
                    isPush: true,
                },
                query: {
                    project_id: project_id,
                    name: name,
                },
            });
        },
        // 订单详情
        handleClickOrderDetail(row) {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: row.order_id ? row.order_id : undefined,
                    order_num: row.order_no ? row.order_no : undefined,
                    name: row.order_num ? row.order_num : row.order_no,
                    query_type: row.order_id ? undefined : "order_num",
                },
            });
        },
        // 查看日志中的订单详情
        handleClickLogOrderDetail(row) {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: row.id ? row.id : undefined,
                    order_num: row.order_num ? row.order_num : undefined,
                    name: row.order_num ? row.order_num : row.order_no,
                    query_type: row.id ? undefined : "order_num",
                },
            });
        },
        //工单详情
        handleClickWorkOrderDetail(row) {
            this.$router.push({
                name: "WorkOrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    work_order_id: row.id,
                    name: row.workorder_num,
                },
            });
        },
    },
};
</script>
<style lang="scss">
@import "@/styles/customer-seas-detail.scss";

.customer-private-seas-detail-wrap {
    .page-breadcrumb {
        height: 86px;
        align-items: normal;
        padding-top: 16px;

        .company-info {
            flex-direction: column;

            div:nth-child(1) {
                display: flex;
                gap: 8px;
            }

            div:nth-child(2) {
                height: 22px;
                display: flex;
                align-items: center;

                .user-avatar {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    padding: 0 12px 0 0;
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(102, 102, 102, 1);
                    cursor: pointer;

                    img {
                        width: 22px;
                        height: 22px;
                        border-radius: 50%;
                        object-fit: cover;
                    }
                }

                > span {
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(102, 102, 102, 1);
                }

                .user-address {
                    margin: 0 8px 0 4px;
                    position: relative;
                    padding: 0 9px;

                    &::before {
                        content: "";
                        position: absolute;
                        top: 4px;
                        left: 0;
                        width: 1px;
                        height: 14px;
                        opacity: 1;
                        background: rgba(232, 232, 232, 1);
                    }

                    &::after {
                        content: "";
                        position: absolute;
                        top: 4px;
                        right: 0;
                        width: 1px;
                        height: 14px;
                        opacity: 1;
                        background: rgba(232, 232, 232, 1);
                    }
                }
            }
        }

        .operator-btns {
            height: 24px;
        }
    }

    .user-avatar {
        &:hover,
        &:active {
            border-radius: 11px;
            background-color: rgb(237, 240, 244);
            color: rgba(51, 51, 51, 1);
        }
    }
}

.custom-tab-popper {
    &.custom-tab-popper-personnel-private {
        top: 140px !important;
    }

    &.custom-tab-popper-company-private {
        top: 208px !important;
    }

    &.custom-tab-popper-members {
        top: 276px !important;
    }

    &.custom-tab-popper-order-private {
        top: 344px !important;
    }

    &.custom-tab-popper-business-private {
        top: 412px !important;
    }

    &.custom-tab-popper-work-private {
        top: 480px !important;
    }
}

.relate_custom_form_dialog {
    .el-dialog__body {
        max-height: 492px;
        overflow-y: scroll;
    }
}
</style>
